module.exports = __webpack_public_path__ + "img/1480672658.08fb7821.jpg";